export default __webpack_public_path__ + "static/rocket-1f94b7c2bdfbaaf27670521d4380b8c5.svg";